export enum IdentityInitiationIntent {
  Login = 'login',
  CreateAccount = 'create_account',
  SSO = 'sso',
}
